/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.buttonContainer[_ngcontent-%COMP%]{text-align:center}.spinnerContainer[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto;width:20px}.imageContainer[_ngcontent-%COMP%]{display:block;padding-bottom:.75em}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL2V4Y2VwdGlvbi1waG90b3MvZXhjZXB0aW9uLXBob3Rvcy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy91dGlsaXRpZXMvY29tcG9uZW50cy9leGNlcHRpb24tcGhvdG9zL2V4Y2VwdGlvbi1waG90b3MuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/utilities/components/exception-photos/exception-photos.component.scss.shim.ngstyle.ts